import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ProductListViewProps {
  children: ReactNode;
  className?: string;
}

export function ProductListView({ children, className }: ProductListViewProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {children}
    </div>
  );
}
